import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { SliderModule } from 'primeng/slider';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription, tap } from 'rxjs';

@Component({
  standalone: true,
  selector: 'pm-form-field-slider',
  imports: [SliderModule, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-slider.component.html',
  styleUrl: './pm-form-field-slider.component.scss',
})
export class PmFormFieldSliderComponent
  extends FormFieldComponent
  implements OnInit, OnDestroy
{
  private subs = new Subscription();
  sliderCtrl = new FormControl();

  ngOnInit(): void {
    if (this.ctrl?.value && typeof this.ctrl.value === 'object') {
      this.sliderCtrl.setValue(Object.values(this.ctrl.value));
    }
    if (this.formField.min === undefined || this.formField.max === undefined) {
      throw new Error(
        'Min and max must be defined in [PmFormFieldSliderComponent]'
      );
    }

    this.sliderCtrl.valueChanges
      .pipe(
        tap((val) => {
          if (this.formField.range) {
            const ctrlVal: any = {};
            const name = String(this.formField.name).replace('_range', '');
            ctrlVal[`${name}_min`] = val[0];
            ctrlVal[`${name}_max`] = val[1];
            this.ctrl.setValue(ctrlVal);
          } else {
            this.ctrl.setValue(val);
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
